export class StrUtil {
  strfmt() {
    var args = arguments
    return args[0].replace(/{(\d+)}/g, function(match, number) {
      number = parseInt(number)
      return typeof args[number+1] !== 'undefined'
        ? args[number+1] : match;
    });
  }

  sprintf() {
    var args = arguments;
    var idx = 0;
    return args[0].replace(/%s/g, function() {
      return args[1 + idx++];
    })
  }

  safeInt(obj) {
    if (obj === undefined) return 0
    if (isNaN(obj)) return 0
    if (!obj) return 0
    return parseInt(obj)
  }
  safeFloat(obj) {
    if (obj === undefined) return 0
    if (isNaN(obj)) return 0
    if (!obj) return 0
    return parseFloat(obj)
  }
  safeStr(obj) {
    if (obj === undefined) return ''
    if (!obj) return ''
    return ''+obj
  }
  humanPrice(floatPrice) {
    // format price
    let priceStr = `${floatPrice}`
    return this._splitPriceStr(priceStr)
  }
  _splitPriceStr (priceStr) {
    let arr = priceStr.split('.')
    let intPrice = arr[0]
    let intPriceArr = []
    let startLen = intPrice.length % 3
    if (startLen === 0) {
      startLen = 3
    }
    intPriceArr.push(intPrice.substr(0, startLen))
    for (; startLen < intPrice.length; startLen += 3) {
      intPriceArr.push(intPrice.substr(startLen, 3))
    }
    let result = intPriceArr.join(',')
    if (arr.length > 1) {
      result += '.' + arr[1]
    }
    return result
  }
}

export var strUtil = new StrUtil()



// WEBPACK FOOTER //
// ./src/plugins/jscom/jscom/utils/strutil.js